import type { FC } from "react";
import type { SubmitHandler } from "react-hook-form";
import type {
  ConfirmResetPassWordInput,
  ResetPassWordInput,
} from "../../hooks/authProvider/authProvider";
import { ResetPassWordConfirmUI } from "./components/ResetPassWordConfirm/ResetPassWordConfirm";
import { ResetPassWordInputUI } from "./components/ResetPassWordInput/ResetPassWordInput";

type ResetPassWordPageProps = {
  onResetPassWordPage: SubmitHandler<ResetPassWordInput>;
  onConfirmResetPassWordPage: SubmitHandler<ConfirmResetPassWordInput>;
  isSend: boolean;
  onResendResetPassWord: () => Promise<void>;
  isResending?: boolean;
  resendCount?: number;
  email: string;
};

export const ResetPassWordPage: FC<ResetPassWordPageProps> = ({
  onResetPassWordPage,
  onConfirmResetPassWordPage,
  isSend = false,
  onResendResetPassWord,
  isResending = false,
  resendCount = 0,
  email,
}) => {
  return (
    <div className="m-auto py-20">
      <h1 className="text-center text-6xl mb-20 font-bold">Strix Search</h1>
      {isSend ? (
        <ResetPassWordConfirmUI
          onConfirmResetPassWord={onConfirmResetPassWordPage}
          onResendResetPassWord={onResendResetPassWord}
          isResending={isResending}
          resendCount={resendCount}
          email={email}
        />
      ) : (
        <ResetPassWordInputUI onResetPassWord={onResetPassWordPage} />
      )}
    </div>
  );
};
